module.exports = __webpack_public_path__ + "assets/64d6924350bd7706850cdc0dcc76ccf6.js";